import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { addOrUpdateCoolingPoint } from "../../../actions/summerPointsActions";
import { useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { weatherCtx } from "../../../utils/hooks/mollierWeatherContext";
import { addOrUpdateCoolingPointWinter } from "../../../actions/winterPointsActions";
import { handleKeyPressOnlyNumbers } from "../../../utils/validationFunctions";
import { useTranslation } from "react-i18next";

function Cooling(props) {
  const [newTemperature, setNewTemperature] = useState();

  const [powerUsed, setPowerUsed] = useState();
  const [coolingProccessVariable, setCoolingProcessVariable] = useState(10);
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();
  const { summerWeather } = useContext(weatherCtx);
  const { chartConfig, setChartConfig } = useContext(weatherCtx);
  const {t} = useTranslation()

  /*onChange={(event) => {
                setChartConfig((prev) => {
                  return { ...prev, altitude: event.target.value };
                });
              }}*/

  /*test */
  const [localValue, setLocalValue] = useState(props.coolingTemperature);
  useEffect(() => {
    setLocalValue(props.coolingTemperature);
  }, [props.coolingTemperature]);

  // Effect to update the Redux store value whenever the localValue changes
  /*useEffect(() => {
    summerWeather
      ? dispatch(
          addOrUpdateCoolingPoint(
            localValue,
            null,
            null,
            null,
            chartConfig.coolerSurfaceTemperature,
            chartConfig.altitude,
            chartConfig.maximalHumidityInProcess,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateCoolingPointWinter(
            localValue,
            null,
            null,
            null,
            chartConfig.coolerSurfaceTemperature,
            chartConfig.altitude,
            chartConfig.maximalHumidityInProcess,
            props.processID
          )
        );
  }, [dispatch, localValue, chartConfig]);*/

  /*test*/

  const handleProcessChange = (event) => {
    summerWeather
      ? coolingProccessVariable === 10
        ? dispatch(
            addOrUpdateCoolingPoint(
              localValue,
              null,
              null,
              null,
              chartConfig.coolerSurfaceTemperature,
              chartConfig.altitude,
              chartConfig.maximalHumidityInProcess,
              props.processID
            )
          )
        : dispatch(
            addOrUpdateCoolingPoint(
              null,
              powerUsed,
              null,
              null,
              chartConfig.coolerSurfaceTemperature,
              chartConfig.altitude,
              chartConfig.maximalHumidityInProcess,
              props.processID
            )
          )
      : coolingProccessVariable === 10
      ? dispatch(
          addOrUpdateCoolingPointWinter(
            localValue,
            null,
            null,
            null,
            chartConfig.coolerSurfaceTemperature,
            chartConfig.altitude,
            chartConfig.maximalHumidityInProcess,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateCoolingPointWinter(
            null,
            powerUsed,
            null,
            null,
            chartConfig.coolerSurfaceTemperature,
            chartConfig.altitude,
            chartConfig.maximalHumidityInProcess,
            props.processID
          )
        );
  };
  /* useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    }
    console.log("sta je sa vremenom" + summerWeather);
    summerWeather
      ? dispatch(
          addOrUpdateCoolingPoint(
            newTemperature,
            null,
            null,
            null,
            chartConfig.coolerSurfaceTemperature,
            chartConfig.altitude,
            chartConfig.maximalHumidityInProcess
          )
        )
      : dispatch(
          addOrUpdateCoolingPointWinter(
            newTemperature,
            null,
            null,
            null,
            chartConfig.coolerSurfaceTemperature,
            chartConfig.altitude,
            chartConfig.maximalHumidityInProcess
          )
        );
  }, [newTemperature]);*/

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={1}
        alignItems="center"
        justifyContent="start"
        direction="row"
      >
        <Grid item xs={5} mt={1}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {t("mollier.paramForCalc")}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={coolingProccessVariable}
              label="Parameter for calculation"
              //defaultValue={20}
              onChange={(event) => {
                setCoolingProcessVariable(event.target.value);
              }}
            >
              <MenuItem value={10}>{t("mollier.temp")}</MenuItem>
              <MenuItem value={20}>{t("mollier.power")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={5}>
          {coolingProccessVariable === 10 && (
            <TextField
              label={t("mollier.coolTemp")}
              id="outlined-start-adornment"
              name="newTemperature"
              // value={props.coolingTemperature}
              value={localValue}
              // sx={{ m: 1, width: "25ch" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">°C</InputAdornment>
                ),
              }}
              //onChange={handleChange}
              onChange={(e) => {
                setLocalValue(e.target.value);
              }}
              onBlur={handleProcessChange}
              onKeyPress={handleKeyPressOnlyNumbers}
            />
          )}
          {coolingProccessVariable === 20 && (
            <TextField
              label={t("mollier.power")}
              id="outlined-start-adornment"
              name="power"
              value={powerUsed}
              // sx={{ m: 1, width: "25ch" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">kW</InputAdornment>
                ),
              }}
              onChange={(event) => {
                setPowerUsed(event.target.value);
              }}
              onBlur={handleProcessChange}
            />
          )}
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("mollier.maxHumInProcess")}
            id="outlined-start-adornment"
            // sx={{ m: 1, width: "25ch" }}
            //disabled={DBMollier}
            name="maximalHumidityInProcess"
            value={chartConfig.maximalHumidityInProcess}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            onChange={(event) => {
              setChartConfig((prev) => {
                return {
                  ...prev,
                  maximalHumidityInProcess: event.target.value,
                };
              });
            }}
            onKeyPress={handleKeyPressOnlyNumbers}
            onBlur={handleProcessChange}
            // onBlur={handleAxisChange}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("mollier.coolSurfTemp")}
            id="outlined-start-adornment"
            // disabled={DBMollier}
            // sx={{ m: 1, width: "25ch" }}
            name="coolerSurfaceTemperature"
            value={chartConfig.coolerSurfaceTemperature}
            InputProps={{
              endAdornment: <InputAdornment position="end">°C</InputAdornment>,
            }}
            onChange={(event) => {
              setChartConfig((prev) => {
                return {
                  ...prev,
                  coolerSurfaceTemperature: event.target.value,
                };
              });
            }}
            onBlur={handleProcessChange}
            onKeyPress={handleKeyPressOnlyNumbers}
            //onBlur={handleAxisChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Cooling;
